import { render, staticRenderFns } from "./PurchaseRequestDetail.vue?vue&type=template&id=d2dda134&scoped=true"
import script from "./PurchaseRequestDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequestDetail.vue?vue&type=style&index=0&id=d2dda134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dda134",
  null
  
)

export default component.exports